import { render, staticRenderFns } from "./dataTableField.component.vue?vue&type=template&id=057e9d20&scoped=true&"
import script from "./dataTableField.component.vue?vue&type=script&lang=js&"
export * from "./dataTableField.component.vue?vue&type=script&lang=js&"
import style0 from "./dataTableField.component.vue?vue&type=style&index=0&id=057e9d20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057e9d20",
  null
  
)

export default component.exports